<div class="activity-details" ng-controller="activityRevokeController as ctrl">
    <div class="activity-details solo">
        <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
    </div>
</div>